import useHeaderController from "./useHeaderController";
import Header from "../../../components/header";

import { HEADER_NAV_BUTTON_MENU } from "../../../components/header/Header";

import { Hamburger } from "../../../components/icons";
import IconButton from "../../../components/icon-button";

const HeaderController = () => {
  const { navButton, onClickMenubutton, leftButton } = useHeaderController();

  const MenuButton = () => {
    return (
      <IconButton onClick={onClickMenubutton} name="header-home-button">
        <Hamburger />
      </IconButton>
    );
  };

  return (
    <Header
      leftButton={leftButton || undefined}
      navButton={navButton === HEADER_NAV_BUTTON_MENU ? <MenuButton /> : <></>}
    />
  );
};

export default HeaderController;
